/** Seconds as `hh:mm:ss`; negative values become `00:00:00`. */
function pad(value: number): string {
    return String(value).padStart(2, '0');
}

export function formatCountdown(totalSeconds: number): string {
    const seconds = Math.max(0, Math.floor(totalSeconds));
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds % 60)}`;
}
